<template>
  <div class="solicitacao-exames">
    <v-card
      variant="flat"
      class="solicitacao-card"
    >
      <v-sheet
        min-height="55vh"
        rounded="lg"
      >
        <div class="pa-4">
          <!-- Modal de Criar Novo Modelo -->
          <v-card 
            v-show="isNovo" 
            variant="outlined" 
            class="novo-modelo-card"
          >
            <v-card-text>
              <v-alert
                v-if="exames.length === 0"
                type="info"
                variant="outlined"
                class="mb-4"
              >
                Adicione exames para criar um novo modelo
              </v-alert>
              
              <v-list
                v-else
                class="exames-list"
              >
                <v-list-item
                  v-for="(exame, i) in exames"
                  :key="i"
                  variant="outlined"
                  class="mb-2"
                >
                  <v-list-item-title class="text-body-1">
                    {{ exame.nome || exame }}
                  </v-list-item-title>
                  <template #append>
                    <v-btn
                      icon
                      variant="text"
                      color="error"
                      @click="exames.splice(i, 1)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                </v-list-item>
              </v-list>
            </v-card-text>

            <v-card-actions class="pa-4">
              <v-text-field
                v-show="isDescricao"
                v-model="descricao"
                variant="outlined"
                density="compact"
                label="Descrição do modelo"
                type="text"
                clearable
                class="descricao-field"
              />
              
              <v-btn
                v-show="isDescricao"
                :disabled="!descricao"
                color="success"
                variant="flat"
                class="ml-2"
                @click="cadastrarSolicitacaoExame()"
              >
                <v-icon start>
                  mdi-content-save
                </v-icon>
                {{ isEdicaoPacote ? 'Salvar alterações' : 'Salvar' }}
              </v-btn>

              <v-btn
                v-show="!isDescricao"
                :disabled="exames.length === 0"
                color="primary"
                variant="flat"
                @click="isDescricao = true"
              >
                <v-icon start>
                  mdi-check-circle
                </v-icon>
                {{ isEdicaoPacote ? 'Editar pacote' : 'Salvar pacote' }}
              </v-btn>

              <v-spacer />
              
              <v-btn 
                variant="outlined" 
                color="grey-darken-1"
                @click="cancelarNovoModelo"
              >
                <v-icon start>
                  mdi-cancel
                </v-icon>
                Cancelar
              </v-btn>
              
              <v-btn 
                color="primary" 
                variant="flat"
                @click="imprimirSolicitacao()"
              >
                <v-icon start>
                  mdi-printer
                </v-icon>
                Imprimir
              </v-btn>
            </v-card-actions>
          </v-card>

          <!-- Modal de Cadastro de Novo Exame -->
          <v-card 
            v-show="isNovoExame" 
            variant="outlined" 
            class="novo-exame-card"
          >
            <v-card-text>
              <v-text-field
                v-model="nomeExame"
                variant="outlined"
                density="comfortable"
                label="Nome do exame"
                required
                class="mb-4"
              />

              <v-alert 
                v-if="successCadastroExame === 1" 
                type="success"
                variant="tonal"
              >
                Exame cadastrado com <strong>sucesso</strong>! Já pode ser buscado na aba anterior.
              </v-alert>

              <v-alert 
                v-if="successCadastroExame === 2" 
                type="error"
                variant="tonal"
              >
                Ocorreu um <strong>erro</strong> ao cadastrar o exame.
              </v-alert>
            </v-card-text>

            <v-card-actions>
              <v-btn 
                :disabled="!nomeExame"
                color="success"
                variant="flat"
                @click="cadastrarExameMedicoSolicitacao(nomeExame)"
              >
                <v-icon start>
                  mdi-plus-circle
                </v-icon>
                Cadastrar Exame
              </v-btn>
              
              <v-spacer />
              
              <v-btn 
                variant="outlined" 
                color="grey-darken-1"
                @click="resetNovoExame"
              >
                <v-icon start>
                  mdi-cancel
                </v-icon>
                Cancelar
              </v-btn>
            </v-card-actions>
          </v-card>

          <!-- Formulário Principal de Solicitação -->
          <v-card 
            v-show="!isNovo && !isNovoExame" 
            variant="outlined"
            class="formulario-principal"
          >
            <v-card-title class="d-flex align-center">
              <v-icon
                start
                color="primary"
              >
                mdi-file-document
              </v-icon>
              Solicitação de Exame(s)

              <v-spacer />

              <!-- Controle de Data -->
              <div class="d-flex align-center">
                <v-tooltip location="top">
                  <template #activator="{ props }">
                    <div v-bind="props">
                      <v-switch
                        v-model="dataHabilitada"
                        hide-details
                        color="primary"
                        class="mt-0 mr-2"
                      >
                        <template #label>
                          <v-icon :color="dataHabilitada ? 'primary' : 'grey'">
                            mdi-calendar-month
                          </v-icon>
                        </template>
                      </v-switch>
                    </div>
                  </template>
                  <span>Ocultar data da solicitação</span>
                </v-tooltip>

                <v-col
                  v-if="dataHabilitada"
                  cols="auto"
                >
                  <v-menu 
                    v-model="menu2" 
                    :close-on-content-click="false"
                    transition="scale-transition"
                  >
                    <template #activator="{ props }">
                      <v-text-field
                        v-model="computedDateFormatted"
                        variant="outlined"
                        density="compact"
                        label="Data"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="props"
                        style="width: 150px;"
                      />
                    </template>
                    <v-date-picker 
                      v-model="date" 
                      no-title
                      @update:model-value="menu2 = false"
                    />
                  </v-menu>
                </v-col>
              </div>
            </v-card-title>

            <v-divider />

            <v-card-text>
              <!-- Seletor de Tipo de Exame -->
              <v-item-group
                v-model="selectedOption"
                mandatory
              >
                <v-container class="pa-0">
                  <v-row>
                    <v-col 
                      v-for="(option, index) in options" 
                      :key="index" 
                      cols="12" 
                      md="4"
                    >
                      <v-tooltip location="top">
                        <template #activator="{ props }">
                          <div v-bind="props">
                            <v-item 
                              v-slot="{ isSelected, toggle }"
                              :value="option.value"
                            >
                              <v-card
                                :color="isSelected ? 'primary' : 'grey-lighten-3'"
                                :class="{ 'elevation-3': isSelected }"
                                class="d-flex align-center tipo-card"
                                height="48"
                                @click="toggle"
                              >
                                <div class="text-body-1 flex-grow-1 text-center white--text">
                                  <v-icon 
                                    class="mr-2" 
                                    :color="isSelected ? 'white' : 'grey-darken-1'"
                                  >
                                    {{ isSelected ? 'mdi-check-circle' : 'mdi-radiobox-blank' }}
                                  </v-icon>
                                  {{ option.label }}
                                </div>
                              </v-card>
                            </v-item>
                          </div>
                        </template>
                        <span>{{ option.hintMessage }}</span>
                      </v-tooltip>
                    </v-col>

                    <!-- Pacotes de Exames -->
                    <v-col
                      cols="12"
                      md="4"
                    >
                      <div class="d-flex flex-column ga-2">
                        <v-menu location="bottom">
                          <template #activator="{ props }">
                            <v-btn
                              :loading="isLoading"
                              :color="isLaboratorio != null && solicitacoes.length > 0 ? 'orange-darken-2' : 'grey'"
                              variant="flat"
                              v-bind="props"
                              class="pacotes-btn"
                              :disabled="isLaboratorio === null"
                            >
                              <v-icon start>
                                mdi-format-list-bulleted
                              </v-icon>
                              Pacotes de Exames
                            </v-btn>
                          </template>
                          <v-list density="compact">
                            <v-list-item
                              v-for="(item, index) in solicitacoes"
                              :key="index"
                              @click="solicitacao = item"
                            >
                              <v-list-item-title>{{ item.nome }}</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>

                        <v-btn
                          :disabled="isLaboratorio === null"
                          variant="outlined"
                          color="primary"
                          class="pacotes-btn"
                          @click="dialog = true"
                        >
                          <v-icon start>
                            mdi-folder
                          </v-icon>
                          Meus Pacotes
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-container>
              </v-item-group>

              <!-- Busca de Exames -->
              <v-autocomplete
                v-model="exame1"
                :disabled="isLaboratorio === null"
                :items="items"
                :loading="isLoading"
                variant="outlined"
                density="comfortable"
                label="Buscar exames"
                placeholder="Digite o nome do exame"
                prepend-inner-icon="mdi-magnify"
                item-text="apelido"
                return-object
                class="mt-4"
                @update:model-value="searchExame = ''"
              />
            </v-card-text>
            <!-- Exames Selecionados -->
            <v-card-actions v-if="solicitacoesExames.length > 0">
              <v-spacer />
              <v-btn 
                color="primary" 
                variant="outlined"
                @click="solicitacoesExames = []"
              >
                <v-icon start>
                  mdi-broom
                </v-icon>
                Limpar Tudo
              </v-btn>
            </v-card-actions>

            <v-card 
              v-if="solicitacoesExames.length > 0" 
              variant="outlined"
              class="mx-2 mb-2"
            >
              <v-card-text class="pt-3">
                <v-chip
                  v-for="(field, i) in solicitacoesExames"
                  :key="field.idExame"
                  color="primary"
                  variant="outlined"
                  closable
                  class="ma-1"
                  @click:close="solicitacoesExames.splice(i, 1)"
                >
                  <strong>{{ field.apelido }}</strong>
                </v-chip>
              </v-card-text>
            </v-card>
          </v-card>
        </div>
      </v-sheet>

      <!-- Ações do Formulário -->
      <v-card-actions class="pa-4">
        <v-spacer />
        
        <v-btn 
          color="error" 
          variant="text"
          size="large"
          @click="$emit('cancelar')"
        >
          <v-icon start>
            mdi-arrow-left
          </v-icon>
          Voltar
        </v-btn>

        <v-btn 
          :disabled="solicitacoesExames.length === 0 || isNovoExame || isNovo"
          color="secondary"
          variant="outlined"
          size="large"
          @click="abrirCadastroModelo"
        >
          <v-icon start>
            mdi-folder-plus
          </v-icon>
          Cadastrar pacote
        </v-btn>
        
        <v-btn 
          :disabled="solicitacoesExames.length === 0 || isNovo"
          color="primary"
          variant="flat"
          size="large"
          @click="addSolicitacoesCard"
        >
          <v-icon start>
            mdi-content-save
          </v-icon>
          Salvar Solicitação
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- Dialog de Confirmação -->
    <v-dialog
      v-model="dialogLimpar"
      width="400"
    >
      <v-card>
        <v-card-title class="text-h6">
          <v-icon
            start
            color="warning"
          >
            mdi-alert
          </v-icon>
          Confirmar Ação
        </v-card-title>
        
        <v-card-text>
          Você tem certeza que deseja limpar todos os exames selecionados?
        </v-card-text>
        
        <v-card-actions>
          <v-spacer />
          <v-btn 
            variant="text" 
            color="grey-darken-1"
            @click="cancelarLimpar"
          >
            Cancelar
          </v-btn>
          <v-btn 
            variant="flat" 
            color="error"
            @click="limparExamesConfirmado"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Pacotes -->
    <v-dialog
      v-model="dialog"
      width="600"
    >
      <v-card color="surface">
        <v-card-title class="primary white--text">
          <v-icon
            start
            color="white"
          >
            mdi-folder
          </v-icon>
          Meus Pacotes de Solicitação
        </v-card-title>

        <v-card-text class="pa-0">
          <v-virtual-scroll
            :items="solicitacoes"
            height="280"
            item-height="64"
          >
            <template #default="{ item }">
              <v-list-item :key="item.id || item._id">
                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium">
                    {{ item.nome }}
                  </v-list-item-title>
                </v-list-item-content>
                
                <v-menu location="bottom">
                  <template #activator="{ props }">
                    <v-btn 
                      icon 
                      variant="text"
                      v-bind="props"
                    >
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list density="compact">
                    <v-list-item
                      v-for="(exame, i) in (item.prescricoes || item.exames || [])"
                      :key="i"
                    >
                      <v-list-item-title class="text-caption">
                        {{ exame.nome }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                
                <v-list-item-action class="d-flex ga-1">
                  <v-btn
                    :loading="load"
                    icon
                    variant="text"
                    color="primary"
                    @click="editarSolicitacao(item)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn 
                    :loading="load"
                    icon 
                    variant="text"
                    color="error"
                    @click="removerSolicitacao(item)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-divider />
            </template>
          </v-virtual-scroll>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialogs de Ajuda -->
    <!-- <DialogAjuda
      v-model="hintBtnDataSolicitacao"
      titulo="Ocultar data da solicitação"
    >
      Se marcada, a <strong>data não será exibida na impressão da solicitação de exames</strong>, 
      gerando um documento sem referência temporal.
    </DialogAjuda>

    <DialogAjuda
      v-model="hintExamesLaboratorio"
      titulo="Filtrar exames laboratoriais"
    >
      Exibe <strong>apenas exames classificados como laboratoriais</strong>, como exames de análises clínicas, 
      bioquímicos, microbiologia e similares.
    </DialogAjuda>

    <DialogAjuda
      v-model="hintExamesRegular"
      titulo="Filtrar exames não laboratoriais"
    >
      Exibe apenas <strong>exames que não são laboratoriais</strong>, como exames de imagem 
      (RX, USG, Tomografia, Ressonância) e outros procedimentos diagnósticos.
    </DialogAjuda> -->
  </div>
</template>

<script>
import { ref, computed, onMounted, watch } from 'vue'
import { useStore } from 'vuex'
import medicoService from '../../services/medico.service'
import { jsPDF } from 'jspdf'
import { applyPlugin } from 'jspdf-autotable'
// import DialogAjuda from '../ui/DialogAjuda.vue'

applyPlugin(jsPDF)

export default {
  name: 'SolicitacaoExames',
  components: {
    // DialogAjuda
  },
  props: {
    paciente: {
      type: Object,
      required: true
    },
    isEditSolicitacao: {
      type: Boolean,
      default: false
    },
    isLabAux: {
      type: Boolean,
      default: false
    },
    mExames: {
      type: Array,
      default: () => []
    }
  },
  emits: ['cancelar', 'solicitacoesCard', 'solicitacoesLabCard', 'editarSolicitacaoCard', 'editarSolicitacaoLabCard'],
  
  setup(props, { emit }) {
    const store = useStore()
    
    // Estados reativos
    const date = ref(new Date().toISOString().substr(0, 10))
    const menu2 = ref(false)
    const descriptionLimit = ref(60)
    const entries = ref([])
    const dataHabilitada = ref(true)
    const load = ref(false)
    const isLaboratorio = ref(null)
    const selectedOption = ref(null)
    const dialog = ref(false)
    const isLoading = ref(false)
    const dialogLimpar = ref(false)
    const isDescricao = ref(false)
    const descricao = ref('')
    const solicitacao = ref(null)
    const isNovo = ref(false)
    const isNovoExame = ref(false)
    const solicitacoes = ref([])
    const solicitacoesExames = ref([])
    const exames = ref([])
    const exame1 = ref(null)
    const searchExame = ref(null)
    // const search = ref(null)
    const nomeExame = ref('')
    const successCadastroExame = ref(0)
    const pendingTipo = ref(null)
    const pacoteSelecionado = ref(null)
    
    // Estados de UI
    const hintBtnDataSolicitacao = ref(false)
    const hintExamesLaboratorio = ref(false)
    const hintExamesRegular = ref(false)
    
    // Opções de tipo de exame
    const options = ref([
      { 
        label: 'Laboratório', 
        value: true, 
        hintMessage: 'Filtrar exames laboratoriais' 
      },
      { 
        label: 'Regular', 
        value: false, 
        hintMessage: 'Filtrar exames não laboratoriais' 
      }
    ])

    // Computed
    const computedDateFormatted = computed(() => {
      return formatDate(date.value)
    })

    const isEdicaoPacote = computed(() => {
      return !!pacoteSelecionado.value
    })

    const items = computed(() => {
      return entries.value
        .filter(entry => 
          !solicitacoesExames.value.some(exame => exame.idExame === entry.idExame)
        )
        .map(entry => ({
          ...entry,
          Description: entry.nome.length > descriptionLimit.value 
            ? entry.nome.slice(0, descriptionLimit.value) + '...'
            : entry.nome
        }))
    })

    const user = computed(() => store.getters.usuario)

    // Métodos
    const limparExamesConfirmado = () => {
      isLaboratorio.value = pendingTipo.value !== null ? pendingTipo.value : !isLaboratorio.value
      pendingTipo.value = null
      solicitacoesExames.value = []
      dialogLimpar.value = false
    }

    const cancelarLimpar = () => {
      dialogLimpar.value = false
      pendingTipo.value = null
      selectedOption.value = isLaboratorio.value
    }

    const addSolicitacoesCard = () => {
      const dadosSolicitacao = {
        items: solicitacoesExames.value,
        observacoes: '',
        isObs: false,
        data: dataHabilitada.value ? formatDate(date.value) : ''
      }

      if (isLaboratorio.value || props.isLabAux) {
        if (props.isEditSolicitacao) {
          emit('editarSolicitacaoLabCard', dadosSolicitacao)
        } else {
          emit('solicitacoesLabCard', dadosSolicitacao)
        }
      } else {
        if (props.isEditSolicitacao) {
          emit('editarSolicitacaoCard', dadosSolicitacao)
        } else {
          emit('solicitacoesCard', dadosSolicitacao)
        }
      }
    }

    const imprimirSolicitacao = () => {
      const examesParaImprimir = isNovo.value ? exames.value : solicitacoesExames.value
      if (examesParaImprimir.length === 0) return

      const doc = new jsPDF()
      
      doc.setFont('helvetica', 'bold')
      doc.text(`Paciente: ${props.paciente.nomePaciente}`, 10, 10)
      doc.text(`Solicitante: ${user.value.nome}`, 10, 17)

      window.open(doc.output('bloburl'))
    }

    const listarExames = async (nome) => {
      if (!nome || nome.length < 2) return
      
      isLoading.value = true
      try {
        const response = await medicoService.medico.listarExamesPorNome(
          nome, 
          isLaboratorio.value ? 'LABORATORIO' : 'CLINICA'
        )
        if (response.status === 200) {
          entries.value = response.data
        }
      } finally {
        isLoading.value = false
      }
    }

    const removerSolicitacao = async (solicitacao) => {
      load.value = true
      try {
        await medicoService.medico.gerenciarModeloSolicitacaoExame({
          idUsuario: user.value.id,
          solicitacao: solicitacao,
          isRemove: true
        })
        if (isLaboratorio.value !== null) {
          await listarPacotes(isLaboratorio.value)
        }
      } finally {
        load.value = false
      }
    }

    const cadastrarSolicitacaoExame = async () => {
      load.value = true
      try {
        const pacoteId = pacoteSelecionado.value?.id || pacoteSelecionado.value?._id || null
        await medicoService.medico.gerenciarModeloSolicitacaoExame({
          idUsuario: user.value.id,
          solicitacao: {
            id: pacoteId,
            _id: pacoteId,
            prescricoes: exames.value.map(e => ({ ...e, imprime: true })),
            nome: descricao.value
          },
          isRemove: false
        })
        
        exames.value = []
        descricao.value = ''
        isNovo.value = false
        pacoteSelecionado.value = null
        if (isLaboratorio.value !== null) {
          await listarPacotes(isLaboratorio.value)
        }
      } finally {
        load.value = false
      }
    }

    const listarPacotes = async (sadt) => {
      solicitacoes.value = []
      try {
        const response = await medicoService.medico.buscarPacoteExames(
          user.value.id, 
          sadt,
          user.value.idUnidade
        )
        if (response.status === 200) {
          solicitacoes.value = response.data
        }
      } catch (error) {
        console.error('Erro ao carregar pacotes:', error)
      }
    }

    const cadastrarExameMedicoSolicitacao = async (nome) => {
      try {
        const response = await medicoService.medico.cadastrarExameMedicoSolicitacao({
          idMedico: user.value.id,
          nome: nome
        })
        
        successCadastroExame.value = response.status === 200 ? 1 : 2
      } catch (error) {
        successCadastroExame.value = 2
      }
    }

    const resetNovoExame = () => {
      isNovoExame.value = false
      nomeExame.value = ''
      successCadastroExame.value = 0
    }

    const abrirCadastroModelo = () => {
      pacoteSelecionado.value = null
      exames.value = solicitacoesExames.value.map(exame => ({ ...exame }))
      descricao.value = ''
      isDescricao.value = false
      isNovoExame.value = false
      isNovo.value = true
    }

    const cancelarNovoModelo = () => {
      isNovo.value = false
      exames.value = []
      descricao.value = ''
      isDescricao.value = false
      pacoteSelecionado.value = null
    }

    const editarSolicitacao = (solicitacao) => {
      pacoteSelecionado.value = solicitacao
      exames.value = (solicitacao.prescricoes || solicitacao.exames || []).map(exame => ({
        ...exame
      }))
      descricao.value = solicitacao.nome || ''
      isDescricao.value = true
      isNovoExame.value = false
      isNovo.value = true
      dialog.value = false
    }

    const formatDate = (date) => {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    }

    const addSolicitacao = (data, tipo) => {
      if (tipo === 1) {
        // Adicionar pacote de exames
        const examesPacote = data.prescricoes || data.exames || []
        examesPacote.forEach(novoExame => {
          const existe = solicitacoesExames.value.some(
            exame => exame.idExame === novoExame.idExame
          )
          if (!existe) {
            solicitacoesExames.value.push(novoExame)
          }
        })
      } else {
        // Adicionar exame individual
        const existe = solicitacoesExames.value.some(
          exame => exame.idExame === data.idExame
        )
        if (!existe) {
          solicitacoesExames.value.push(data)
        }
      }
    }

    // Lifecycle
    onMounted(() => {
      if (props.mExames.length > 0) {
        solicitacoesExames.value = [...props.mExames]
      }
      if (props.isLabAux) {
        selectedOption.value = props.isLabAux
      }
    })

    // Watchers
    watch(selectedOption, (newVal) => {
      if (newVal === null || newVal === undefined) return
      if (newVal !== isLaboratorio.value && solicitacoesExames.value.length > 0) {
        pendingTipo.value = newVal
        dialogLimpar.value = true
        selectedOption.value = isLaboratorio.value
        return
      }
      isLaboratorio.value = newVal
      entries.value = []
      listarPacotes(newVal)
    })

    watch(solicitacoesExames, () => {
      searchExame.value = ''
      exame1.value = null
      console.log('exames: ', exame1)
    })

    watch(exames, (newVal) => {
      if (newVal.length === 0) {
        isDescricao.value = false
      }
    })

    watch(solicitacao, (newVal) => {
      if (newVal) {
        addSolicitacao(newVal, 1)
      }
    })

    watch(exame1, (newVal) => {
      if (newVal) {
        addSolicitacao(newVal, 0)
      }
    })

    watch(searchExame, (newVal) => {
      if (newVal && newVal.length > 2) {
        listarExames(newVal)
      }
    })

    return {
      // Estados
      date,
      menu2,
      entries,
      dataHabilitada,
      load,
      isLaboratorio,
      selectedOption,
      dialog,
      isLoading,
      dialogLimpar,
      isDescricao,
      descricao,
      solicitacao,
      isNovo,
      isNovoExame,
      solicitacoes,
      solicitacoesExames,
      exames,
      exame1,
      searchExame,
      nomeExame,
      successCadastroExame,
      hintBtnDataSolicitacao,
      hintExamesLaboratorio,
      hintExamesRegular,
      options,

      // Computed
      computedDateFormatted,
      isEdicaoPacote,
      items,

      // Métodos
      limparExamesConfirmado,
      cancelarLimpar,
      addSolicitacoesCard,
      imprimirSolicitacao,
      listarExames,
      removerSolicitacao,
      cadastrarSolicitacaoExame,
      listarPacotes,
      cadastrarExameMedicoSolicitacao,
      resetNovoExame,
      abrirCadastroModelo,
      cancelarNovoModelo,
      editarSolicitacao,
      formatDate
    }
  }
}
</script>

<style scoped>
.solicitacao-exames {
  height: 100%;
}

.solicitacao-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.novo-modelo-card,
.novo-exame-card,
.formulario-principal {
  border-radius: 8px;
}

.exames-list {
  max-height: 200px;
  overflow-y: auto;
}

.descricao-field {
  flex: 1;
  max-width: 300px;
}

.tipo-card {
  cursor: pointer;
  transition: all 0.3s ease;
}

.tipo-card:hover {
  transform: translateY(-2px);
}

.pacotes-btn {
  min-width: 180px;
}

/* Scrollbar personalizada */
.exames-list::-webkit-scrollbar {
  width: 6px;
}

.exames-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.exames-list::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.exames-list::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Responsividade */
@media (max-width: 960px) {
  .tipo-card {
    height: 40px;
  }
  
  .pacotes-btn {
    min-width: 160px;
    font-size: 0.875rem;
  }
}

@media (max-width: 600px) {
  .pa-4 {
    padding: 16px;
  }
  
  .tipo-card {
    height: 36px;
  }
  
  .pacotes-btn {
    min-width: 140px;
    font-size: 0.75rem;
  }
}
</style>
